import React from 'react'
import ReactDOM from 'react-dom/client'
import WeddingInvitation from './WeddingInvitation'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <WeddingInvitation />
  </React.StrictMode>,
)
